import { useWallet } from "@aptos-labs/wallet-adapter-react";

import { areStringsEqual } from "@/utils/string";

export function useWalletNetworkMismatch(networkName: string, chainId?: number) {
  const wallet = useWallet();
  const walletNetworkName = wallet.network?.name;

  // We only need to check for a network mismatch if the wallet is a native Aptos wallet.
  // Cross-chain wallets always connect to the desired network that is configured on
  // the `AptosWalletAdapterProvider`.
  if (!wallet.wallet?.isAptosNativeWallet) {
    return false;
  }

  const hasNetworkMismatch =
    wallet.connected &&
    chainId !== wallet.network?.chainId &&
    !areStringsEqual(networkName, walletNetworkName);

  return hasNetworkMismatch;
}
